"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.IshtarExpedition = void 0;
const Card_1 = require("../Card");
const CardName_1 = require("../../CardName");
const CardType_1 = require("../CardType");
const CardRenderer_1 = require("../render/CardRenderer");
const Resources_1 = require("../../Resources");
const CardRequirements_1 = require("../CardRequirements");
const Tags_1 = require("../Tags");
class IshtarExpedition extends Card_1.Card {
    constructor() {
        super({
            cardType: CardType_1.CardType.EVENT,
            tags: [Tags_1.Tags.VENUS],
            name: CardName_1.CardName.ISHTAR_EXPEDITION,
            cost: 6,
            requirements: CardRequirements_1.CardRequirements.builder((b) => b.venus(10)),
            metadata: {
                cardNumber: 'P76',
                description: 'Requires Venus 10%. Gain 3 titanium and draw 2 Venus cards.',
                renderData: CardRenderer_1.CardRenderer.builder((b) => {
                    b.br;
                    b.titanium(3);
                    b.nbsp().cards(2).secondaryTag(Tags_1.Tags.VENUS);
                }),
            },
        });
    }
    play(player) {
        player.addResource(Resources_1.Resources.TITANIUM, 3);
        player.drawCard(2, { tag: Tags_1.Tags.VENUS });
        return undefined;
    }
}
exports.IshtarExpedition = IshtarExpedition;
//# sourceMappingURL=IshtarExpedition.js.map